import { Col, Row } from "react-bootstrap";
import { IFullLicenceDetails } from "../../../../api/LicenceDetails";
import EpaCard from "../../../../leap-components/EpaCard";
import EpaField from "../../../../leap-components/EpaField";

interface LicenceDetailsProps {
  licence: IFullLicenceDetails;
}

const SiteDetails = ({ licence }: LicenceDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <EpaField label={"Site Name"} value={licence.sitename} />
          <EpaField label={"Address 1"} value={licence.siteaddress1} />
          <EpaField label={"Address 2"} value={licence.siteaddress2} />
          <EpaField label={"Address 3"} value={licence.siteaddress3} />
          <EpaField label={"Town/City"} value={licence.sitecity} />
          <EpaField label={"County"} value={licence.county} />
          <EpaField label={"Eircode"} value={licence.siteeircode} />
          <EpaField label={"NACE Code"} value={licence.sitenace} />
          <EpaField label={"NUTS Code"} value={licence.sitenuts} />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Site Details"} content={bodyElements} />;
};

export default SiteDetails;
